import { COVERGO_SAAS_DEV, COVERGO_ASIA_QA, COVERGO_EU_UAT } from "../consts.js"

export const mediskyhu_dev = {
	"mediskyhu-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "mediskyhu_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
		featureFlags: {
			filesExplorer: {
				enableDownloadAsZip: true,
			},
		},
	},
}

export const mediskyhu_qa = {
	"mediskyhu-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "mediskyhu_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-mediskyhu-qa",
		},
		featureFlags: {
			filesExplorer: {
				enableDownloadAsZip: true,
			},
		},
	},
}

export const mediskyhu_uat = {
	"mediskyhu-studio.uat.eu.covergo.cloud": {
		appConfig: {
			tenantId: "mediskyhu_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_EU_UAT,
		fileSystem: {
			bucketName: "covergo-euce1-uat-mediskyhu-uat",
		},
		featureFlags: {
			filesExplorer: {
				enableDownloadAsZip: true,
			},
		},
	},
}
